import { generateUniqueId } from '../../helpers/common';

export const SET_EMAIL = generateUniqueId();
export const SET_EMAIL_ERROR = generateUniqueId();
export const TOGGLE_ALIERT_DIALOG = generateUniqueId();